import React, { useEffect, useState, useCallback } from 'react';
import { requestServerPost, requestServerGet, selectPage } from '../../actions';
import { connect } from 'react-redux';
import HistoryDisplay from './HistoryDisplay';

function ScreenPublishingHistoryView(props) {
    const { screendata, onClose = () => { }, fetchHistory = null } = props;
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [historyData, setHistoryData] = useState([]);
    const [publishContentLogData, setPublishContentLogData] = useState([]);

    const defaultFetch = async (id) => {
        // const res = await fetch(`/api/screens/${encodeURIComponent(id)}/publishing-history`);
        // if (!res.ok) throw new Error(`Failed to load history: ${res.status}`);
        // return res.json();


        const { requestServerGet, selectedBrandData, usertoken } = props;

        const { ScreenID } = screendata;

        requestServerGet("get_historyscreenpublish", { screenid: ScreenID, brandid: selectedBrandData.BrandID }, {}, (response) => {
            console.log("get_historyscreenpublish " + JSON.stringify(response.data))

            // if (response.data && response.data.length === 0) {
            //     createTimelineSchedule(defaultData);
            // }
            setHistoryData(response.data)
        }, usertoken);


        requestServerGet("get_publishcontentlog", { screenid: ScreenID, brandid: selectedBrandData.BrandID }, {}, (response) => {
            console.log("get_publishcontentlog " + JSON.stringify(response.data))

            // if (response.data && response.data.length === 0) {
            //     createTimelineSchedule(defaultData);
            // }
            setPublishContentLogData(response.data)
        }, usertoken);
    };

    const load = useCallback(
        async (id) => {
            if (!id) return;
            setLoading(true);
            setError(null);
            try {
                const data = await (fetchHistory ? fetchHistory(id) : defaultFetch(id));
                // Expecting an array of { id, timestamp, status, user, notes } or similar
                setItems(Array.isArray(data) ? data : []);
            } catch (err) {
                setError(err.message || 'Unknown error');
                setItems([]);
            } finally {
                setLoading(false);
            }
        },
        [fetchHistory]
    );

    useEffect(() => {
        load(screendata.ScreenID);
    }, [screendata, load]);

    const onRefresh = () => load(screendata.ScreenID);

    const fmtDate = (ts) => {
        if (!ts) return '';
        const d = new Date(ts);
        if (Number.isNaN(d.getTime())) return String(ts);
        return d.toLocaleString();
    };

    if (!screendata) {
        return <div>Please provide a screen data to view publishing history.</div>;
    }

    return (
        <div className="history-view-container">
            <HistoryDisplay screendata={screendata} historyData={historyData} publishContentLogData={publishContentLogData}/>
        </div>
    );
}


const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage })(ScreenPublishingHistoryView);
